
import CPLoader from '@/components/globals/CPLoader.vue';

import { Component, Vue, Watch } from 'vue-property-decorator';


@Component({
  components: {
    CPLoader,
  },
})
export default class CPDocumentModal extends Vue {

  public regex = `/[\/]*[^\/]+[\/]([^\/]+)/`;

  public loading: boolean = false;

  public get productDetails() {
    return this.$store.state.baskets.buy.details ? this.$store.state.baskets.buy.details : this.$store.state.baskets.sell.details;
  }
  public get documents() {
    return this.$store.state.baskets.documents;
  }

  public close() {
    this.$store.commit('toggleBuyBasket', false);
  }

  public truncateText(text: string, truncateLength: number) {
    return text.length > truncateLength ? text.substring(0, (truncateLength)) + '...' : text;
  }

  public async startDocusignProcess() {
    this.loading = true;
    await this.$store.dispatch('startDocusignProcess');
    this.loading = false;
  }

  public beforeDestroy() {
    this.$store.commit('updateDocuments', null);
  }

}
